export default __webpack_public_path__ + "static/media/tony-clap.cb55b5c7.jpg";